import React from 'react';
import { Route, Routes, Navigate } from 'react-router-dom';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { detect } from 'detect-browser';
import { Notification, Message, Menu } from '../../../web.common';
import routes from '../../../routes';
import ErrorBoundary from '../../misc/ErrorBoundary';
import withLocalization from '../../higherOrderComponents/withLocalization';
import LayoutContext from './_LayoutContext';
import PageHeader from './_Header';
// import PageFooter from './_Footer';
import AreaWithSidebar from './_AreaWithSidebar';
import { divider } from './_Divider';
import configReader from '../../../config';
import Login from '../../pages/Login';
import { withRouter } from '../../../common/withRouter';

const { mode } = configReader.get();

const devSections = mode === 'production' ? [] : [
];

const sidebarMenuItems = [
  {
    linkProps: {
      label: "Home",
      path: "/home",
      iconName: "bars",
    },
  },
  {
    linkProps: {
      label: "Overview",
      path: "/overview",
      iconName: "clipboard-list",
    },
  },
  {
    linkProps: {
      label: "Signups",
      path: "/signups",
      iconName: "calendar-check",
    },
  },
  {
    linkProps: {
      label: "Emails",
      path: "/confirmationEmail",
      iconName: "envelope",
    },
  },
  {
    element: divider,
  },
  {
    linkProps: {
      label: "Users",
      path: "/users",
      iconName: "user",
    },
  },
  {
    linkProps: {
      label: "Marketing Consents",
      path: "/marketing-consents",
      iconName: "envelope",
    },
  },
  {
    element: divider,
  },
  {
    linkProps: {
      label: "Purchases",
      path: "/purchases",
      iconName: "shopping-basket",
    },
  },
  {
    linkProps: {
      label: "Transactions",
      path: "/transactions",
      iconName: "credit-card",
    },
  },
  {
    linkProps: {
      label: "Payment Methods",
      path: "/paymentmethods",
      iconName: "credit-card",
    },
  },
  {
    linkProps: {
      label: "Subscriptions",
      path: "/subscriptions",
      iconName: "address-card",
    },
  },
  {
    linkProps: {
      label: "Participants",
      path: "/participants",
      iconName: "users",
    },
  },
  {
    linkProps: {
      label: "Reports",
      path: "/reports",
      iconName: "chart-bar",
    },
  },
  {
    linkProps: {
      label: "Seasonal Courts",
      path: "/seasonal-courts",
      iconName: "file-excel",
    },
  },
  {
    linkProps: {
      label: "Seasonal Courts Overview",
      path: "/seasonal-courts-overview",
      iconName: "th",
    },
  },
  {
    element: divider,
  },
  {
    linkProps: {
      label: "Providers",
      path: "/providers",
      iconName: "key",
    },
  },
  {
    linkProps: {
      label: "Provider Admin",
      path: "/provideradmin",
      iconName: "key",
    },
  },
  {
    linkProps: {
      label: "Facilities",
      path: "/facilities",
      iconName: "building",
    },
  },
  {
    linkProps: {
      label: "Areas",
      path: "/areas",
      iconName: "map-marked-alt",
    },
  },
  {
    linkProps: {
      label: "Facility Redirects",
      path: "/facility-redirects",
      iconName: "share",
    },
  },
  {
    linkProps: {
      label: "Proxies",
      path: "/proxies",
      iconName: "random",
    },
  },
  {
    linkProps: {
      label: "Device Jobs",
      path: "/device-jobs",
      iconName: "mobile-alt",
    },
  },
  {
    linkProps: {
      label: "SEO Texts",
      path: "/seo-texts",
      iconName: "globe",
    },
  },
  {
    linkProps: {
      label: "Facility Texts",
      path: "/facility-texts",
      iconName: "file-alt",
    },
  },
  {
    linkProps: {
      label: "Resource groups",
      path: "/ResourceGroups",
      iconName: "info",
    },
  },
  {
    linkProps: {
      label: "Products",
      path: "/products",
      iconName: "box",
    },
  },
  {
    linkProps: {
      label: "Integrations",
      path: "/integrations",
      iconName: "code",
    },
  },
  {
    linkProps: {
      label: "Crawlings",
      path: "/crawlings",
      iconName: "spider",
    },
  },
  {
    linkProps: {
      label: "Non Partner Facilities",
      path: "/non-partner-facilities",
      iconName: "building",
    },
  },
  {
    linkProps: {
      label: "Play",
      path: "/play",
      iconName: "handshake",
    },
  },
  {
    linkProps: {
      label: "Activities",
      path: "/activities",
      iconName: "running",
    },
  },{
    linkProps: {
      label: "Relay Rules",
      path: "/relayRule",
      iconName: "code",
    },
  },
  {
    linkProps: {
      label: "Lockers",
      path: "/locker",
      iconName: "lock",
    },
  },
  {
    linkProps: {
      label: "Master codes",
      path: "/salto-master-codes",
      iconName: "key",
    },
  },
  {
    linkProps: {
      label: "Agreements",
      path: "/automated-booking-agreements",
      iconName: "handshake",
    },
  },
  {
    element: divider,
  },
  {
    linkProps: {
      label: "Clubhouses",
      path: "/clubhouses",
      iconName: "users",
    },
  },
  {
    linkProps: {
      label: "Clubhouse wannas",
      path: "/clubhouse-wannas",
      iconName: "users",
    },
  },
  {
    linkProps: {
      label: "Clubhouse memberships",
      path: "/clubhouse-memberships",
      iconName: "users",
    },
  },
  {
    linkProps: {
      label: "Clubhouse payments",
      path: "/clubhouse-payments",
      iconName: "credit-card",
    },
  },
  ...devSections,
];

const renderSidebar = () => (
  <Menu
    isTabList
    orientation='vertical'
    items={sidebarMenuItems.map(itemProps => {
      const { linkProps } = itemProps;
      return !linkProps ? itemProps : {
        linkProps: {
          ...linkProps,
          appearance: 'buttonWrap'
        }
      };
    })}
  />
);

class Layout extends React.Component {
  constructor() {
    super();
    this.state = {
      latestNotification: null
    };

    this.pushNotification = this.pushNotification.bind(this);
  }

  componentDidMount() {
    const {
      props: {
        translate
      },
      pushNotification
    } = this;

    const currentBrowser = detect();

    const supportedBrowsers = [
      { name: 'chrome' },
      { name: 'safari' }
    ];

    const isCurrentBrowserSupported = !!supportedBrowsers.find(({ name, version, os }) => {
      const {
        name: currentBrowserName,
        version: currentBrowserVersion,
        os: currentOs
      } = currentBrowser;

      if (name !== currentBrowserName) {
        return false;
      }

      if (version && currentBrowserVersion !== version) {
        return false;
      }

      return !os || currentOs === os;
    });

    if (!isCurrentBrowserSupported) {
      pushNotification(new Message('warning', translate('warning-browser-outdated')));
    }
  }

  pushNotification(latestNotification) {
    this.setState({ latestNotification });
  }

  render() {
    const {
      props: {
        user
      },
      state: {
        latestNotification
      },
      pushNotification
    } = this;

    const isLoggedIn = !!user;

    if (!isLoggedIn) {
      return (
        <LayoutContext.Provider value={{ latestNotification, pushNotification }}>
          <Login />
        </LayoutContext.Provider>
      );
    }

    return (
      <LayoutContext.Provider value={{ latestNotification, pushNotification }}>
        <Notification newMessage={latestNotification} />
        <PageHeader />

        <AreaWithSidebar
          classNames={['main-sidebared-layout']}
          renderSidebarContent={renderSidebar}
        >
          <main>
            <Routes>
              {routes.map(({ component: PageComponent, path = 'default', extraProps = {} }) => {
                const RouteElement = () => (
                  <ErrorBoundary>
                    <PageComponent {...extraProps} />
                  </ErrorBoundary>
                );

                return (
                  <Route
                    path={path}
                    key={path}
                    element={<RouteElement />}
                  />
                );
              })}
              <Route path="*" element={<Navigate to="/home" replace />} />
            </Routes>
          </main>
        </AreaWithSidebar>

        {/* <PageFooter /> */}
      </LayoutContext.Provider>
    );
  }
}

Layout.propTypes = {
  user: PropTypes.object
};

export default withRouter(
  withLocalization(
    connect(({ user }) => ({ user }), {})(Layout),
    'general/messages'
  )
);
